const { localNumber } = require('./Number');

const getNowTimestamp = () => Math.trunc(+Date.now() / 1000);

const monthNames = ['Jan', 'Feb', 'March', 'April', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const longMonthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const currentYear = new Date().getFullYear();

const getMonthName = (index) => monthNames[index];
const getLongMonthName = (index) => longMonthNames[index];

const getHumanReadableDate = (timestamp, {
    displayTime = true,
    hideTimeIf00 = false, // Used to reduce precision for dates that weren't entered as timestamps
    displayDay = true,
    useLongMonthNames = false,
} = {}) => {
    const date = new Date(timestamp * 1000);
    const month = date.getMonth();
    const day = date.getDate();
    const year = date.getFullYear();
    const yearText = year === currentYear ? '' : ` ${year}`;
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const getMonthNameFn = useLongMonthNames ? getLongMonthName : getMonthName;

    const utcHours = date.getUTCHours();
    const utcMinutes = date.getUTCMinutes();
    const utcSeconds = date.getUTCSeconds();

    return (
        (displayDay && displayTime) ? (
            (hideTimeIf00 && utcHours === 0 && utcMinutes === 0 && utcSeconds === 0) ?
                `${getMonthNameFn(month)} ${day}${yearText}` :
                `${getMonthNameFn(month)} ${day}${yearText} ${hours}:${minutes}`
        ) :
            displayDay ? `${getMonthNameFn(month)} ${day}${yearText}` :
            `${getMonthNameFn(month)}${yearText}`
    );
};

const getHumanReadableDayDifference = (timestampAfter, timestampBefore = (+Date.now() / 1000)) => {
    const dayDiff = Math.abs(Math.ceil((timestampAfter - timestampBefore) / 60 / 60 / 24));
    return `${localNumber(dayDiff)} ${dayDiff > 1 ? 'days' : 'day'}`;
};

export {
    getNowTimestamp,
    getHumanReadableDate,
    getHumanReadableDayDifference,
};
